import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

type TInitialValuesTabs = {
  active: string;
};

const initialState: TInitialValuesTabs = {
  active: '',
};

export const tabsSlice = createSlice({
  name: 'ui/tabs',
  initialState,
  reducers: {
    setActive(state, { payload }: PayloadAction<string>) {
      return { ...state, active: payload };
    },
  },
});

const selectTabs = (state: RootState) => state.ui.tabs;

export const selectors = { selectTabs };
export const actions = tabsSlice.actions;
export const reducer = tabsSlice.reducer;
